import PropTypes from "prop-types"
import React from "react"

LoadingIndicator.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  message: PropTypes.string,
}

export function LoadingIndicator({ isLoading = true, message = "Loading" }) {
  if (!isLoading) return null

  return (
    <React.Fragment>
      <style>{loadingIndicatorStyles}</style>
      <div
        className="loading-indicator"
        role="status"
        aria-live="polite"
        aria-label={`${message} Chat`}
      >
        <div className="loading-indicator__text">
          {message}
          <span className="loading-indicator__dot" aria-hidden="true">
            .
          </span>
          <span className="loading-indicator__dot" aria-hidden="true">
            .
          </span>
          <span className="loading-indicator__dot" aria-hidden="true">
            .
          </span>
        </div>
      </div>
    </React.Fragment>
  )
}

const loadingIndicatorStyles = `
  .loading-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
  }

  .loading-indicator__text {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-tint4);
    transform: translateY(68px);
  }

  .loading-indicator__dot {
    opacity: 0;
    animation: loading-dots-1 1s infinite;
  }

  .loading-indicator__dot:nth-of-type(1) {
    animation: loading-dots-1 1s infinite;
  }

  .loading-indicator__dot:nth-of-type(2) {
    animation: loading-dots-2 1s infinite;
  }

  .loading-indicator__dot:nth-of-type(3) {
    animation: loading-dots-3 1s infinite;
  }

  @keyframes loading-dots-1 {
    0%, 20% {
      opacity: 1;
    }
    21%, 39% {
      opacity: 0;
    }
    40%, 100% {
      opacity: 1;
    }
  }

  @keyframes loading-dots-2 {
    0%, 20% {
      opacity: 1;
    }
    21%, 59% {
      opacity: 0;
    }
    60%, 100% {
      opacity: 1;
    }
  }

  @keyframes loading-dots-3 {
    0%, 20% {
      opacity: 1;
    }
    21%, 79% {
      opacity: 0;
    }
    80%, 100% {
      opacity: 1;
    }
  }
`
